import { IScore } from "@eagerdog/interfaces";

/** UKC Conformation entry streams. Each has its own breed results and Best in Show. */
export type ConformationStream =
  | "regular"
  | "altered"
  | "novice_puppy"
  | "veteran"
  | "brace";

/** Streams whose breed card uses the licensed award ladder (class 1st–4th, BM/BF, BOW, CH, GRCH, BOB). */
export type LicensedStream = "regular" | "altered";

/** Non-licensed levels stored on `non_licensed_breed_results`. */
export type NonLicensedLevel = "novice_puppy" | "veteran" | "brace";

/** Top-level sections of the results flow, in entry order. */
export type ConformationSection = "junior" | "best_in_show" | "groups" | "breeds";

export const CONFORMATION_SECTION_ORDER: ConformationSection[] = [
  "junior",
  "best_in_show",
  "groups",
  "breeds",
];

export const CONFORMATION_STREAM_ORDER: ConformationStream[] = [
  "regular",
  "altered",
  "novice_puppy",
  "veteran",
  "brace",
];

export const CONFORMATION_STREAM_TITLES: Record<ConformationStream, string> = {
  regular: "Regular Conformation",
  altered: "Altered Conformation",
  novice_puppy: "Novice Puppy",
  veteran: "Veteran",
  brace: "Brace",
};

export interface IBreedBucket {
  breed: string;
  breedGroup: string;
  scores: IScore[];
}

/** One class placement list on a licensed breed card: level × sex × variety. */
export interface IClassSection {
  level: string;
  sex: "Male" | "Female";
  variety: string;
}

export interface IPartitionedScores {
  regular: IScore[];
  altered: IScore[];
  novicePuppy: IScore[];
  veteran: IScore[];
  brace: IScore[];
  junior: IScore[];
}
